import {FC, ReactNode} from "react";
import {HintTooltip, useBreakpoint} from "@brg/ui";
import {useTranslation} from "react-i18next";
import styled from "styled-components";
import { AppTester } from "supporting";

export const ComingSoonTabWrapper = styled.div.attrs({
  className: 'cs-container'
})`
  position: relative;
  z-index: 10;
  padding-left: 0 !important;
  & > div > div:last-child {
      top: 32px;
  }
`

export const ComingSoonTab: FC<{children: ReactNode}> = ({children}) => {
    const { t } = useTranslation();
    const isTablet = useBreakpoint(1200);
    const isCGRAVE = AppTester.isCGRAVE();
    const isContinuumSite = AppTester.isContinuumSite();
    const isHSEDesign = AppTester.isHSEDesign();
    const isGeoDafes = AppTester.isGeoDafes();
    const isSuperPuper = AppTester.isSuperPuper();
    const isGeo = AppTester.isGeograffee();
    const baseStyle = { padding: '2px 8px 4px' };
    const geoStyle =
        (isCGRAVE || isContinuumSite) ?
        { background: "#2C2C2B", color: "#FEFEFE" } 
        : isGeo && !isGeoDafes
        ? { background: "#353A3E" }
        : isGeoDafes || isHSEDesign
        ? { background: "#E7E7E7", color: "#70706F" }
        : {};

    const combinedStyle = { ...baseStyle, ...geoStyle };

    return (
      <ComingSoonTabWrapper>
        {!isTablet ? <HintTooltip
          // @ts-ignore
          customStyle={combinedStyle}
          onWhiteBg={!isGeo && !isSuperPuper}
          noArrow
          positionY="bottom"
          z={10000}
          text={t("nav.mediiia.coming_soon")}
        >
          {children}
        </HintTooltip>
        :  `${children} | ${t("nav.mediiia.coming_soon").toLowerCase()}`}
        
      </ComingSoonTabWrapper>
    );
  };import {FC, ReactNode} from "react";
import {HintTooltip, useBreakpoint} from "@brg/ui";
import {useTranslation} from "react-i18next";
import styled from "styled-components";
import { AppTester } from "supporting";

export const ComingSoonTabWrapper = styled.div.attrs({
  className: 'cs-container'
})`
  position: relative;
  z-index: 10;
  padding-left: 0 !important;
  & > div > div:last-child {
      top: 32px;
  }
`

export const ComingSoonTab: FC<{children: ReactNode}> = ({children}) => {
    const { t } = useTranslation();
    const isTablet = useBreakpoint(1200);
    const isCGRAVE = AppTester.isCGRAVE();
    const isContinuumSite = AppTester.isContinuumSite();
    const isHSEDesign = AppTester.isHSEDesign();
    const isGeoDafes = AppTester.isGeoDafes();
    const isSuperPuper = AppTester.isSuperPuper();
    const isGeo = AppTester.isGeograffee();
    const baseStyle = { padding: '2px 8px 4px' };
    const geoStyle =
        (isCGRAVE || isContinuumSite) ?
        { background: "#2C2C2B", color: "#FEFEFE" } 
        : isGeo && !isGeoDafes
        ? { background: "#353A3E" }
        : isGeoDafes || isHSEDesign
        ? { background: "#E7E7E7", color: "#70706F" }
        : {};

    const combinedStyle = { ...baseStyle, ...geoStyle };

    return (
      <ComingSoonTabWrapper>
        {!isTablet ? <HintTooltip
          // @ts-ignore
          customStyle={combinedStyle}
          onWhiteBg={!isGeo && !isSuperPuper}
          noArrow
          positionY="bottom"
          z={10000}
          text={t("nav.mediiia.coming_soon")}
        >
          {children}
        </HintTooltip>
        :  `${children} | ${t("nav.mediiia.coming_soon").toLowerCase()}`}
        
      </ComingSoonTabWrapper>
    );
  };